import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const LlmKeysIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/llm-keys'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_llm_keys',
          component: LlmKeysIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
